import {Message, Loading} from "element-ui";
import _ from "underscore";
import {getDownurl, getUpurl, upBack} from "@/api/file"
import axios from "axios";
import store from "@/store";


export default {
    success(msg) {
        Message.closeAll();
        Message({
            message: msg,
            type: "success",
        });
    },
    warning(msg) {
        Message.closeAll();
        Message({
            message: msg,
            type: "warning",
        });
    },
    error(msg) {
        Message.closeAll();
        Message.error(msg);
    },
    checkFileExt(file, list) {
        let temp = file.name.split(".");
        let ext = temp[temp.length - 1].toLowerCase();
        if (_.indexOf(list, ext) == -1) {
            this.warning("文件格式不符合要求！");
            return false;
        } else {
            return true;
        }
    },
    checkAllFileSize(arr, maxSize) {
        let totalSize = 0;
        _.each(arr, (item) => {
            totalSize = totalSize + item.size;
        });
        if (totalSize / 1024 / 1024 < maxSize) {
            return true;
        } else {
            this.warning(`选择的文件超出最大限制${maxSize}M`);
            return false;
        }
    },
    checkAllFileNums(arr, maxNum) {
        if (arr.length > maxNum) {
            this.warning(`选择的文件数量超出最大限制${maxNum}个`);
            return false;
        } else {
            return true;
        }
    },
    formatCurrentTime(format = 'YYYY-MM-DD HH:mm:ss') {
        const now = new Date();
        // 提取时间字段（月份0-11，需+1；日期1-31；小时0-23；分/秒0-59）
        const year = now.getFullYear(); // 年（4位，如2025）
        const month = now.getMonth() + 1; // 月（0-11 → 1-12）
        const day = now.getDate(); // 日（1-31）
        const hour = now.getHours(); // 时（0-23，24小时制）
        const minute = now.getMinutes(); // 分（0-59）
        const second = now.getSeconds(); // 秒（0-59）
      
        // 个位数补零（如 3→03）
        const padZero = (num) => num.toString().padStart(2, '0');
      
        // 替换格式模板
        return format
          .replace('YYYY', year)
          .replace('MM', padZero(month))
          .replace('DD', padZero(day))
          .replace('HH', padZero(hour))
          .replace('mm', padZero(minute))
          .replace('ss', padZero(second));
      },
    /**
     * @description: 上传文件
     * @param data 文件信息
     * @param productModule  模块类别
     * @param filetype 文件类别
     * @return {*}
     */
    async upFile(data, productModule, filetype, projectIdx) {
        try {
            let re1 = await getUpurl({
                originalName: data.name,
                productModule: productModule,
                filetype: filetype,
                projectIdx: "word相似度" + "|" + projectIdx,
                unitId: data.unitId ? data.unitId : null,
                unitName: data.unitName ? data.unitName : null,
            });
            let {fileName, upLoadUrl} = re1.data;
            let re2 = await axios({
                method: "put",
                url: upLoadUrl,
                data: data.raw,
            });
            if (re2.status == "200") {
                let re3 = await upBack({
                    fileName: fileName,
                    contentMd5: data.contentMd5,
                    fileLength: data.size,
                });

                let re4 = await getDownurl({
                    fileName: fileName
                })

                return Promise.resolve({
                    flag: true,
                    unitName: data.unitName,
                    file_name: data.name,
                    uid: data.uid,
                    path: re4.data,
                    fileId:fileName,
                    filetype: filetype
                });
            } else {
                this.warning("解析文件出错！");
                return Promise.reject(false);
            }
        } catch (err) {
            return Promise.reject(false);
        }
    },
    load_show() {
        const load = Loading.service({
            fullscreen: true,
            text: "正在上传中……",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.8)"
        })
        return load;
    },
    /**
     * 导出
     */
    exportFile(file, name) {
        const blob = new Blob([file], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = `${name}.xlsx`;
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    getUserInfo(){
        let data = store.state.user;
        let {isLogin,userId} = data;
        let Info = {
            isLogin: isLogin ? 1 : 0, // isLogin 1 登录   2 未登录
            isRegister: 1,// 游客Id有值 认为当前是游客
            userId: userId ? userId : ""//  未登录 取游客Id
        }
        return Info;
    }
}
